goog.provide("shadow.js.shim.module$$mui$material$InputAdornment");
goog.provide("module$shadow_js_shim_module$$mui$material$InputAdornment");
shadow.js.shim.module$$mui$material$InputAdornment = shadow.js.nativeProvides["@mui/material/InputAdornment"] = shadow$bridge("@mui/material/InputAdornment");
module$shadow_js_shim_module$$mui$material$InputAdornment.default = shadow.js.shim.module$$mui$material$InputAdornment;
